import {GenericContent} from "./GenericContent";

export class Article extends GenericContent {
    content: string;
    date: string;

    constructor(
        name: string,
        description: string,
        thumbnail: string,
        navUrl: string,
        content: string,
        date: string,
        trackingId: string,
        alwaysInRoadmap: boolean
    ) {
        super(name, description, thumbnail, navUrl, trackingId, false, alwaysInRoadmap);
        this.content = content;
        this.date = date;
    }
}